//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import staticQuizDataImport from '../assets/QuizData.json'

export default {
  name: 'FilterRightDrawer',
  data: () => ({
      selectedDecades: ['1990er', '2000er', '2010er', '2020er'],
      optionsDecades: ['1950er', '1960er', '1970er', '1980er', '1990er', '2000er', '2010er', '2020er'],/* '1940er',  */
      selectedSeasons: [],
      optionsSeasons: [],
      allSeasons: [],
      selectedLeagues: [],
      optionsLeagues: [],
      fullQuizData: staticQuizDataImport
  }),
  created() {

    console.log("#################################################")
    console.log(this.$store.getters.getSelectedDecades)

    if ( this.getSelectedDecades == 0 ){
      console.log("Filter created -> updateSelectedDecades")
      this.$store.dispatch("updateSelectedDecades", ['1990er', '2000er', '2010er', '2020er']);
    }

    this.selectedDecades = this.getSelectedDecades
    console.log(this.selectedDecades)

    //if ( this.selectedDecades.length < 1 ) this.selectedDecades = this.optionsDecades

    var allSeasons = []
    var allDecades = []
    var allLeagues = []
    this.fullQuizData.player.forEach(player => {
        if ( player.img != null ) {
            player.seasons.forEach(season => {
                //console.log(season.season)
                allSeasons.push(season.season)
                allDecades.push(season.season.substring(0,3)+"0er")
                allLeagues.push(season.league)
            })
        }
    })

    var uniqueSeasons = [...new Set(allSeasons)]
    var uniqueDecades = [...new Set(allDecades)]
    var uniqueLeagues = [...new Set(allLeagues)]

    this.optionsDecades = uniqueDecades.sort()
    this.allSeasons = uniqueSeasons.sort()
    this.optionsLeagues = uniqueLeagues.sort()
    
    this.updateOptionsSeasons()
    this.changedSeasons(null)
    this.changedLeagues(null)
  },
  computed: {
    getSelectedDecades() {
      return this.$store.getters.getSelectedDecades
    },
    getSelectedSeasons() {
      return this.$store.getters.getSelectedSeasons
    },
    getSelectedLeagues() {
      return this.$store.getters.getSelectedLeagues
    }
  },
  watch: {
    getSelectedDecades(newValue, oldValue) {
      console.log("Watch Decades")
      console.log("oldValue:"+oldValue)
      console.log("newValue:"+newValue)
      if ( oldValue.length == 0 ) {
        console.log(oldValue.length)
        this.selectedDecades = newValue
//        this.changedDecades()
      }
    },
    getSelectedSeasons(/*newValue, oldData*/) {
      console.log("Watch Seasons")
      
    }, 
    getSelectedLeagues(/*newValue, oldData*/) {
      console.log("Watch Leagues")
      
    }
  },
  methods: {
      updateOptionsSeasons: function() {
        this.selectedSeasons = []
        this.optionsSeasons = []
        this.allSeasons.forEach(season => {
            if ( this.selectedDecades.length == 0 || this.selectedDecades.includes(season.substring(0,3)+"0er") ) {
                this.optionsSeasons.push(season)
            }
        })
      },
      changedDecades: function(event) {
        console.log(event)

        if ( this.selectedDecades.length == 0 ) {
          this.$store.dispatch("updateSelectedDecades", this.optionsDecades);
        }  else {
          this.$store.dispatch("updateSelectedDecades", this.selectedDecades);
        }

        this.updateOptionsSeasons()

        this.changedSeasons(event)
      }, 
      changedSeasons: function(event) {
          console.log(event)
          console.log("dispatch")
          if ( this.selectedSeasons.length == 0 ) {
            this.$store.dispatch("updateSelectedSeasons", this.optionsSeasons);
          } else {
            this.$store.dispatch("updateSelectedSeasons", this.selectedSeasons);
          }
      }, 
      changedLeagues: function(event) {
          console.log(event)
          this.$store.dispatch("updateSelectedLeagues", this.selectedLeagus);
      }
  }
}
